export const theme = {
  axis: {
    legend: {
      text: {
        fontSize: '0.75rem',
        fill: '#667085',
        opacity: 0.8,
        fontWeight: 'lighter',
      },
    },
    ticks: {
      text: {
        fontSize: '0.8rem',
        fill: '#667085',
        opacity: 0.8,
        outlineWidth: 0,
        fontWeight: 'lighter',
      },
    },
  },
};
